export enum HighlightsType {
    AcceptsRefunds = 'accepts_refunds',
    AgeRestriction = 'age_restriction',
    Duration = 'duration',
    ETicket = 'eticket',
    FreeParking = 'free_parking',
    Parking = 'parking',
}

export type HighlightsProps = { [key: string]: boolean };
